import { sendUnityToolCommand } from "./editorUnityToolCommandAdapter";

export type EditorUndoHistoryScreenTransitionReason =
  | "space_changed"
  | "editor_unload";

let screenTransitionClearInFlight: Promise<void> | null = null;

/**
 * Space 전환·Editor 이탈 등 화면 경계에서는 Undo 대상 context가 바뀌므로
 * Unity가 소유한 RTUndo/Redo와 Prototype Undo token을 함께 비운다.
 */
export function clearEditorUndoHistoryForScreenTransition(
  reason: EditorUndoHistoryScreenTransitionReason,
): Promise<void> {
  if (screenTransitionClearInFlight) return screenTransitionClearInFlight;

  const operation = Promise.resolve()
    .then(() =>
      sendUnityToolCommand(
        "tool_clearUndoHistory",
        { reason },
        { requiresReadyState: "handlers_ready" },
      ),
    )
    .then(() => undefined)
    .catch(() => undefined)
    .finally(() => {
      screenTransitionClearInFlight = null;
    });

  screenTransitionClearInFlight = operation;
  return operation;
}

export function clearEditorUndoHistoryForSpaceChange(): Promise<void> {
  return clearEditorUndoHistoryForScreenTransition("space_changed");
}

export function resetEditorUndoHistoryRuntimeForTests(): void {
  screenTransitionClearInFlight = null;
}
